export const style = {
  fontFamily: "inherit",
  fontSize: "1.5rem"
};
